
export default function SelectAssetsButtonDirective() {
    'ngInject';
    return {
        template: require('./select-assets-button.html'),
        transclude: true,
        restrict: 'E',
        scope: {
            disabled: '='
        }
    };
}
